export default {
    name: "date_from_string",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'Make date from string %1 in format %2',
                "args0": [
                    {
                        "type": "input_value",
                        "name": "DATE",
                        "check": "String"
                    },
                    {
                        "type": "input_value",
                        "name": "PATTERN",
                        "check": "String"
                    }
                ],
                "inputsInline": true,
                "output": ["String", "Number"],
                "colour": 4.5,
                "tooltip": "Get part of date",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {

        const javaLocalDate = `java.time.LocalDate`
        const javaDateTimeFormatter = `java.time.format.DateTimeFormatter`
        const date = blocklyInstance.JavaScript.valueToCode(block, "DATE", blocklyInstance.JavaScript.ORDER_ATOMIC);
        const pattern = blocklyInstance.JavaScript.valueToCode(block, "PATTERN", blocklyInstance.JavaScript.ORDER_ATOMIC);

        return [`Java.type("${javaLocalDate}").parse(${date}, Java.type("${javaDateTimeFormatter}").ofPattern(${pattern}))`, blocklyInstance.JavaScript.ORDER_NONE];
    }
}